import { API_APP_ID } from "../config";
import { getMpinClientInfo } from "./browserClientInfo";
import { formatRegisterPhone } from "./buildRegisterPayload";

/**
 * Builds POST /api/v1/auth/player-login/mpin body.
 * @see https://crm-api.inversatechnosoft.com/api/swagger/frontend#/Auth/post_api_v1_auth_player_login_mpin
 */
export async function buildMpinLoginPayload(formPayload = {}) {
  const client = await getMpinClientInfo();
  client.auth_method = "mpin";

  const phone =
    formPayload.phoneFull ||
    formatRegisterPhone(formPayload.countryCode, formPayload.phone);

  return {
    app_id: API_APP_ID,
    username: String(formPayload.username || "").trim(),
    phone: phone || "",
    mpin: String(formPayload.mpin || ""),
    client,
  };
}

export async function buildMpinPayload(mpin) {
  return {
    mpin: String(mpin),
    client: await getMpinClientInfo(),
  };
}

export async function buildResetMpinPayload(
  mpin,
  { password = "", otp = "", authMethod = "password" } = {}
) {
  const client = await getMpinClientInfo();
  client.auth_method = authMethod;

  return {
    mpin: String(mpin),
    password: String(password),
    otp: String(otp),
    client,
  };
}
